var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.authentical
    ? _c(
        "div",
        {
          class: { whiteBg: _vm.$route.name == "feedback" },
          staticStyle: { height: "100%" },
          attrs: { id: "app" }
        },
        [
          _c(
            "keep-alive",
            { attrs: { exclude: ["feedback", "replyList", "sendMail"] } },
            [_c("router-view")],
            1
          ),
          _vm._v(" "),
          _vm.renderFixedBar ? _c("help-nav") : _vm._e(),
          _vm._v(" "),
          _c("loading"),
          _vm._v(" "),
          _c("nio-toast"),
          _vm._v(" "),
          _c("uimask"),
          _vm._v(" "),
          _c("garbage-qrcode")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 